<script setup lang="ts">
const { whatsappLink } = useSupportWhatsappLink();

const shouldShow = computed(() => !!whatsappLink.value);
</script>

<template>
  <a
    v-if="shouldShow"
    :href="whatsappLink"
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Open WhatsApp support"
    class="fixed bottom-6 right-6 z-[85] flex size-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg transition-transform hover:scale-[1.03]"
  >
    <IconifyIcon icon="ic:baseline-whatsapp" class="size-8" />
  </a>
</template>
